

import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../assets/css/Footer.css";
import logo from "../assets/img/logo/comparedly-logo.png";
import yt_logo from "../assets/img/logo/youtube-logo-dark.png";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLinkClick = (event, sectionId) => {
    event.preventDefault();

    if (location.pathname !== "/") {
      // Navigate to home and pass section ID via state
      navigate("/", { state: { scrollTo: sectionId } });
    } else {
      // We're on home page, scroll directly
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer className="footer-section">
      <div className="footer-container">
        {/* Branding Section */}
        <div className="footer-branding">
          <img src={logo} alt="Comparedly Logo" className="footer-logo" />
          <h3 className="footer-app-name">COMPAREDLY</h3>
          <p className="footer-tagline">Elevate Your Social Media Strategy</p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (location.pathname !== "/") {
                    navigate("/", { state: { scrollTo: "top" } });
                  } else {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }
                }}
              >
                Home
              </a>

            </li>
            <li><a href="#features" onClick={(e) => handleLinkClick(e, "features")}>Features</a></li>
            <li><a href="#pain-points" onClick={(e) => handleLinkClick(e, "pain-points")}>Why Us</a></li>
            <li><a href="#pricing" onClick={(e) => handleLinkClick(e, "pricing")}>Pricing</a></li>
            <li><a href="#how-it-works" onClick={(e) => handleLinkClick(e, "how-it-works")}>How it works</a></li>
            <li><Link to="/blog">Blog</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-contact">
          <h4>Contact Us</h4>
          <p>Email: <a href="mailto:help@comparedly.com">help@comparedly.com</a></p>
        </div>

        {/* Social Media Icons */}
        <div className="footer-social">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com/comparedlyofficial" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://x.com/comparedly" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-x-twitter"></i>
            </a>
            <a href="https://www.instagram.com/comparedly" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.youtube.com/@Comparedly" target="_blank" rel="noopener noreferrer">
              <img src={yt_logo} alt="Youtube" style={{ height: "20px", objectFit: "contain" }} />
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Comparedly. All rights reserved.</p>
        <div className="footer-legal">
          <Link to="/faq">FAQ</Link> | <Link to="/privacy">Privacy Policy</Link> | <Link to="/terms">Terms of Service</Link> | <Link to="/about">About Us</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
